import { RootState } from 'types'
import { Action } from 'redux/actions'
import { ADD_SNIPPET, DELETE_SNIPPET, SET_SNIPPETS, SHOW_SNIPPETS_RAIL } from 'redux/constants'

export default function reduce(
  state: RootState['snippets'] = { show: false, snippets: [] },
  action: Action,
): RootState['snippets'] {
  switch (action.type) {
    case SHOW_SNIPPETS_RAIL: {
      return { ...state, show: action.payload.show }
    }

    case DELETE_SNIPPET: {
      const snippetId = action.payload.id
      const snippets = state.snippets.filter(snippet => snippet.id !== snippetId)
      return { ...state, snippets }
    }

    case ADD_SNIPPET: {
      const snippet = action.payload.snippet
      let snippetExists = false

      const snippets = state.snippets.map(oldSnippet => {
        if (oldSnippet.id === snippet.id) {
          oldSnippet = snippet
          snippetExists = true
        }

        return oldSnippet
      })

      if (snippetExists) {
        return { ...state, snippets: [...snippets] }
      }
      return { ...state, snippets: [...snippets, snippet] }
    }

    case SET_SNIPPETS: {
      const snippets = action.payload.snippets
      return { ...state, snippets }
    }

    default:
      return state
  }
}
